import { render, staticRenderFns } from "./Revolut.vue?vue&type=template&id=273e7600&scoped=true&"
import script from "./Revolut.vue?vue&type=script&lang=js&"
export * from "./Revolut.vue?vue&type=script&lang=js&"
import style0 from "./Revolut.vue?vue&type=style&index=0&id=273e7600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273e7600",
  null
  
)

export default component.exports